import history from 'history/browser'

export const navigateToOrganization = (organizationId: string) =>
  history.push(`/${organizationId}`)
